import { BodyText, OtherText, ParagraphText } from 'styling/Typography';
import { GLDetailsCard, GLDetailsCardContainer, GLDetailsGrid, GLDetailsStartEnd, LegendColor, ShiftTimeLegend } from '../GlobalView.styled';
import { WidgetTitle } from 'pages/HrDashboard/Widgets/widgetParts.styled';
import { Flex } from 'styling/GlobalStyles';
import { DBTimelineLogContainer, TimelineLineContainer, TimelineLog } from 'pages/Dashboard/DashboardTasks/DBTasks.styled';
import { ImagesSlider } from 'components/ImagesSlider/ImagesSlider';
import { ShiftTimeline } from '../ShiftTimeline';
import { formatDateForDisplay, getShiftFromMinutes, getTime, getTimeFromDate } from 'utils/helpers';
import { useState } from 'react';
import { taskStatusesData } from 'pages/Dashboard/dashboardData';
import { tokens } from 'styling/tokens';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { Spinner } from 'components/Loading/Loading';

export const WorkerDetails = () => {
    const [imagesModal, setImagesModal] = useState({ open: false, images: [], details: '' })
    const { workerInfo, workerLoading } = useSelector((state: RootState) => state.globalView)

    const handleImages = (images: string[], details: string) => {
        setImagesModal(prev => {
            const copy = structuredClone(prev)
            copy.images = images
            copy.details = details
            copy.open = true
            return copy
        })
    }

    return <GLDetailsCardContainer>
        {workerLoading && <Spinner loading={true} />}

        <GLDetailsCard style={{ overflow: 'auto', minHeight: workerInfo?.todayWorkSchedule ? 150 : 80 }} >
            <WidgetTitle>Today’s schedule</WidgetTitle>
            {workerInfo?.todayWorkSchedule ? <>
                <OtherText>{workerInfo?.todayWorkSchedule?.shift.name} {getShiftFromMinutes(workerInfo?.todayWorkSchedule?.shift)}</OtherText>
                <ShiftTimeline shift={{ shiftStart: workerInfo?.todayWorkSchedule.shift.shiftStart, minutes: workerInfo?.todayWorkSchedule.shift.minutes }} todayTaskTimeSpans={workerInfo?.todayTaskTimeSpans} />
                <ShiftTimeLegend>
                    <Flex center gap='5px'><LegendColor color={tokens.accent.base} /> <ParagraphText>Task</ParagraphText> </Flex>
                    <Flex center gap='5px'><LegendColor color={tokens.status.warning.fg} /> <ParagraphText>Free</ParagraphText> </Flex>
                </ShiftTimeLegend>
            </> : <OtherText>No schedule set for today</OtherText>}

        </GLDetailsCard>

        <GLDetailsCard>
            <WidgetTitle>Tomorrow’s schedule</WidgetTitle>
            <OtherText weight='bold'>{workerInfo?.tomorrowWorkSchedule ? workerInfo.tomorrowWorkSchedule.shift.name : <OtherText>No schedule set for tomorrow</OtherText>}</OtherText>
        </GLDetailsCard>
        <GLDetailsCard>
            <WidgetTitle>Today’s performance</WidgetTitle>
            <GLDetailsGrid>
                <OtherText >Active time: <span style={{ fontWeight: 'bold' }} >{getTime(workerInfo?.todayPerformance?.activeTime) || '/'}</span></OtherText>
                <OtherText >Breaks: <span style={{ fontWeight: 'bold' }} >{workerInfo?.todayPerformance?.breakCount || '/'}</span></OtherText>
            </GLDetailsGrid>
            <OtherText >Idle Time: <span style={{ fontWeight: 'bold' }} >{getTime(workerInfo?.todayPerformance?.idleTime) || '/'}</span></OtherText>
        </GLDetailsCard>

        <GLDetailsCard>
            <WidgetTitle>Current task</WidgetTitle>
            <BodyText  >{workerInfo?.currentUserTask?.taskName || 'No current task'}</BodyText>
            {workerInfo?.currentUserTask && <>
                <GLDetailsStartEnd>
                    <div style={{ flex: 1 }}>
                        <OtherText >Estimated Start Date</OtherText>
                        <OtherText weight='bold'>{workerInfo?.currentUserTask?.estimatedStartDate ? formatDateForDisplay(workerInfo?.currentUserTask?.estimatedStartDate, true) : '/'}</OtherText>
                    </div>
                    <div style={{ flex: 1 }}>
                        <OtherText >Estimated End Date</OtherText>
                        <OtherText weight='bold'>{workerInfo?.currentUserTask?.estimatedEndDate ? formatDateForDisplay(workerInfo?.currentUserTask?.estimatedEndDate, true) : '/'}</OtherText>
                    </div>
                </GLDetailsStartEnd>
                <GLDetailsStartEnd>
                    <div style={{ flex: 1 }} >
                        <OtherText>Actual Start Date</OtherText>
                        <OtherText weight='bold'>{workerInfo?.currentUserTask?.actualStartDate ? formatDateForDisplay(workerInfo?.currentUserTask?.actualStartDate, true) : '/'}</OtherText>
                    </div>
                    <div style={{ flex: 1 }}>
                        <OtherText >Actual End Date</OtherText>
                        <OtherText weight='bold'>{workerInfo?.currentUserTask?.actualEndDate ? formatDateForDisplay(workerInfo?.currentUserTask?.actualEndDate, true) : '/'}</OtherText>
                    </div>
                </GLDetailsStartEnd>
                <DBTimelineLogContainer open={true} onClick={e => e.stopPropagation()} >
                    <TimelineLineContainer noBorder >
                        {
                            workerInfo?.currentUserTask?.executions.slice(-2).map((e, i) => <TimelineLog key={i} >
                                <p className='time' >{formatDateForDisplay(e.from)} <br /> {getTimeFromDate(e.from)}</p>
                                <div className='svg' >
                                    <svg width='30' height='50' xmlns='http://www.w3.org/2000/svg' overflow='visible' >
                                        {!(e.status == 3 || e.status == 7) && <line x1='10' y1='15' x2='10' y2='60' stroke={tokens.accent.base} strokeWidth='3' />}
                                        {i == 0 && <> <circle cx='10' cy='10' r='7' fill={tokens.accent.base} strokeWidth='3' />
                                            <circle cx='10' cy='10' r='3' fill={tokens.text.primary} /></>}
                                        {i == 2 && <> <circle cx='10' cy='55' r='7' fill={tokens.accent.base} strokeWidth='3' />
                                            <circle cx='10' cy='55' r='3' fill={tokens.text.primary} /></>}
                                    </svg>
                                </div>
                                <Flex column >
                                    <OtherText className='task-status' >{taskStatusesData.find(s => s.id == e.status).name} <span style={{ color: tokens.status.danger.fg }} >{e.status == 4 && (e.userTaskExecutionIssue?.issueTrigger?.issue?.name || (e as any).executionIssue?.issueTrigger?.issue?.name)}</span></OtherText>
                                    {((e.status == 3 && e.completedImageUrls.length > 0) || (e.status !== 3 && e.reportedImageUrls.length > 0)) &&
                                        <p className='view-image' onClick={() => handleImages(e.status == 3 ? e.completedImageUrls : e.reportedImageUrls, e.userTaskExecutionIssue?.description)}>View Image</p>}
                                </Flex>
                            </TimelineLog>
                            )
                        }
                    </TimelineLineContainer>
                    {/* <Flex end='true'  >
                <OtherText onClick={() => navigate('/dashboard/tasks/' + workerInfo.currentUserTask.id)} style={{ color: '#ff9900', cursor: 'pointer' }}> View Details </OtherText>
            </Flex> 
                TODO Regulisati task id da vodi gde treba
            */}
                </DBTimelineLogContainer>
            </>}
        </GLDetailsCard>
        <GLDetailsCard>
            <WidgetTitle>Next task</WidgetTitle>
            <BodyText  >{workerInfo?.nextUserTask?.taskName || 'No next task'}</BodyText>
            {workerInfo?.nextUserTask && <GLDetailsStartEnd>
                <div>
                    <OtherText >Estimated Start Date</OtherText>
                    <OtherText weight='bold'>{workerInfo?.nextUserTask?.estimatedStartDate ? formatDateForDisplay(workerInfo?.nextUserTask?.estimatedStartDate, true) : '/'}</OtherText>
                </div>
                <div>
                    <OtherText >Estimated End Date</OtherText>
                    <OtherText weight='bold'>{workerInfo?.nextUserTask?.estimatedEndDate ? formatDateForDisplay(workerInfo?.nextUserTask?.estimatedEndDate, true) : '/'}</OtherText>
                </div>
            </GLDetailsStartEnd>}
        </GLDetailsCard>
        {imagesModal.open && (
            <ImagesSlider images={imagesModal.images} setImagesModal={setImagesModal} />
        )}
    </GLDetailsCardContainer>
}